/** @format */

import { Chain, PrunedProductListSEO } from '@product-recommendations/data-access';
import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { selectCriteoProducts, selectFeatureFlags } from '@plp/data-access/state';

import { ProductRecommendationsComponent } from '@shared/components';
import { Store } from '@ngrx/store';
import { selectPageType } from '@state/data-access';

@Component({
  selector: 'plp-components-recommendations-container',
  imports: [ProductRecommendationsComponent],
  templateUrl: './recommendations-container.component.html',
  styleUrl: './recommendations-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendationsContainerComponent {
  private readonly store = inject(Store);
  private readonly chain = inject(Chain);

  readonly productListSEOData = input<PrunedProductListSEO | null>(null);
  readonly showNoSearchResultsPage = input<boolean>(false);

  readonly chainAbbr = signal<string>('');

  readonly pageType = this.store.selectSignal(selectPageType);
  readonly featureFlags = this.store.selectSignal(selectFeatureFlags);
  readonly criteoProducts = this.store.selectSignal(selectCriteoProducts);

  readonly sponsoredCriteoProducts = computed(() => this.criteoProducts() ?? undefined);

  readonly hasSponsoredCarouselProducts = computed(
    () => (this.criteoProducts()?.placements?.carousel?.[0]?.products?.length ?? 0) > 0,
  );

  constructor() {
    this.chainAbbr.set(this.chain.chainIdentifierAbbr);
  }
}
